import React, { useRef, useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const FirmaDigital = ({ onFirmaGuardada, firmaExistente = null }) => {
    const canvasRef = useRef(null);
    const [isDrawing, setIsDrawing] = useState(false);
    const [lastPoint, setLastPoint] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            const ctx = canvas.getContext('2d');
            ctx.strokeStyle = '#000000';
            ctx.lineWidth = 2;
            ctx.lineCap = 'round';
            ctx.lineJoin = 'round';

            // Si hay una firma existente, cargarla
            if (firmaExistente) {
                const img = new Image();
                img.onload = () => {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                };
                img.src = firmaExistente;
            }
        }
    }, [firmaExistente]);

    const startDrawing = (e) => {
        const canvas = canvasRef.current;
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        setIsDrawing(true);
        setLastPoint({ x, y });
    };

    const draw = (e) => {
        if (!isDrawing) return;

        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const rect = canvas.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        ctx.beginPath();
        ctx.moveTo(lastPoint.x, lastPoint.y);
        ctx.lineTo(x, y);
        ctx.stroke();

        setLastPoint({ x, y });
    };

    const stopDrawing = () => {
        setIsDrawing(false);
    };

    const limpiarCanvas = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    const guardarFirma = async () => {
        const canvas = canvasRef.current;

        // Verificar que hay contenido en el canvas
        const ctx = canvas.getContext('2d');
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const isEmpty = imageData.data.every(pixel => pixel === 0);

        if (isEmpty) {
            Swal.fire({
                icon: 'warning',
                title: 'Firma vacía',
                text: 'Por favor dibuje su firma antes de guardar'
            });
            return;
        }

        try {
            // Convertir canvas a blob
            canvas.toBlob(async (blob) => {
                if (blob) {
                    // Convertir a base64 para almacenamiento
                    const reader = new FileReader();
                    reader.onload = () => {
                        const base64 = reader.result;
                        // Guardar en localStorage temporalmente
                        localStorage.setItem('firmaAdministrador', base64);

                        if (onFirmaGuardada) {
                            onFirmaGuardada(base64);
                        }

                        Swal.fire({
                            icon: 'success',
                            title: '¡Firma guardada!',
                            text: 'Su firma ha sido guardada exitosamente',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    };
                    reader.readAsDataURL(blob);
                }
            }, 'image/png');

        } catch (error) {
            console.error('Error al guardar firma:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No se pudo guardar la firma'
            });
        }
    };

    return (
        <div className="firma-digital-container">
            <div className="mb-3">
                <label className="form-label">
                    <strong>Firma Digital del Administrador</strong>
                </label>
                <p className="text-muted small">
                    Dibuje su firma en el área siguiente usando el mouse o pantalla táctil
                </p>
            </div>

            <div className="firma-canvas-container" style={{ border: '2px solid #ddd', borderRadius: '8px', padding: '10px', backgroundColor: '#fff' }}>
                <canvas
                    ref={canvasRef}
                    width={400}
                    height={150}
                    style={{
                        border: '1px solid #ccc',
                        cursor: 'crosshair',
                        display: 'block',
                        margin: '0 auto'
                    }}
                    onMouseDown={startDrawing}
                    onMouseMove={draw}
                    onMouseUp={stopDrawing}
                    onMouseLeave={stopDrawing}
                    onTouchStart={(e) => {
                        e.preventDefault();
                        const touch = e.touches[0];
                        const mouseEvent = new MouseEvent('mousedown', {
                            clientX: touch.clientX,
                            clientY: touch.clientY
                        });
                        e.target.dispatchEvent(mouseEvent);
                    }}
                    onTouchMove={(e) => {
                        e.preventDefault();
                        const touch = e.touches[0];
                        const mouseEvent = new MouseEvent('mousemove', {
                            clientX: touch.clientX,
                            clientY: touch.clientY
                        });
                        e.target.dispatchEvent(mouseEvent);
                    }}
                    onTouchEnd={(e) => {
                        e.preventDefault();
                        const mouseEvent = new MouseEvent('mouseup', {});
                        e.target.dispatchEvent(mouseEvent);
                    }}
                />
            </div>

            <div className="mt-3 text-center">
                <button
                    type="button"
                    className="btn btn-secondary me-2"
                    onClick={limpiarCanvas}
                >
                    Limpiar
                </button>
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={guardarFirma}
                >
                    Guardar Firma
                </button>
            </div>
        </div>
    );
};

export default FirmaDigital;